/**
 * Enum for tag types.
 */
enum TagTypes {
  Content = 'content',
  User = 'user',
  Team = 'team'
};

export default TagTypes;  